import axios from 'axios'
import Settings from "../../settings.json";

const url = Settings.isNative ? Settings.frontlineArServer : "";

export class ProjectRequester {

    static async getAllProjects(db, idList, filterSelection, sortSelection, isPaged) {
        const result = await axios.post(`${url}/ProjectManagment/${db}/get-projects`, {
            idList, filterSelection, sortSelection, isPaged
        });
        return result.data
    }

    static async getProject(projectId, db) {
        const result = await axios.get(`${url}/ProjectManagment/${db}/get-project-by/${projectId}`);
        return result.data
    }


    static async getProjectPublicityStatus(projectId, db) {
        const result = await axios.get(`${url}/ProjectManagment/publicityStatus/${db}/${projectId}`);
        if (result.error) {
            return console.log(result.error)
        } else return result.data
    }

    async getProjectAnalytics(projectId, db) {
        const result = await axios.get(`${url}/ProjectManagment/${db}/analytics/${projectId}`);
        return result.data
    }

    static async getProcedureSessionsObject(projectId, db) {
        const result = await axios.get(`${url}/ProcedureSessions/${db}/${projectId}/getProcedureSessionsObject`);
        return result.data
    }

    static async getAllFolders(projectId, db) {
        const result = await axios.get(`${url}/ProjectManagment/${db}/${projectId}/GetAllFolders`);
        return result.data
    }

    async createOrUpdateNewProject(project, db) {
        const result = await axios.put(`${url}/ProjectManagment/${db}/UpdateProject`, project);
        return result.data;
    }

    async deleteProject(projectId, db) {
        const response = await axios.delete(`${url}/ProjectManagment/${db}/${projectId}/delete-project/`);
        return !!response;
    }

    static async createOrUpdateFolder(folder, db) {
        const response = await axios.put(`${url}/ProjectManagment/${db}/UpsertFolder`, folder);
        return response.data;
    }

    static async getFileDetails(projectId, id, workspace) {
        const response = await axios.post(`${url}/ProjectManagment/${workspace}/${projectId}/get-file-details/${id}`);
        return response.data;
    }

    static async getAllProjectFiles(projectId, db) {
        const response = await axios.post(`${url}/ProjectManagment/${db}/${projectId}/GetFiles`);
        return response.data;
    }

    static async getAllProjectMediaFolders(projectId, db) {
        const response = await axios.get(`${url}/ProjectManagment/${db}/${projectId}/GetMediaFolders`);
        return response.data;
    }

    static async createMode(projectId, db, newModeStr) {
        const response = await axios.post(`${url}/ProjectManagment/${db}/${projectId}/new-mode`, {newModeStr});
        return response.data;
    }

    static async renameMode(modeIndex, newModeName, projectId, db) {
        const response = await axios.post(`${url}/ProjectManagment/${db}/${projectId}/rename-mode`, {
            modeIndex,
            newModeName
        });
        return response.data;
    }

    static async changeFeature(modeIndex, featureKey, newValue, projectId, db) {
        const response = await axios.post(`${url}/ProjectManagment/${db}/${projectId}/change-feature`, {
            modeIndex,
            featureKey,
            newValue
        });
        return response.data;
    }

    static async removeMode(modeIndex, projectId, db) {
        const response = await axios.post(`${url}/ProjectManagment/${db}/${projectId}/remove-mode`, {modeIndex});
        return response.data;
    }

    static async duplicateMode(modeIndex, projectId, db) {
        const response = await axios.post(`${url}/ProjectManagment/${db}/${projectId}/duplicate-mode`, {modeIndex});
        return response.data;
    }

    static async deleteFolder(folderId, db) {
        const response = await axios.delete(`${url}/ProjectManagment/${db}/${folderId}/DeleteFolder`);
        return response.data;
    }

    static async createMediaFolder(mediaFolderObj, db) {
        const response = await axios.post(`${url}/ProjectManagment/${db}/CreateMediaFolder`, mediaFolderObj);
        return response.data;
    }

    static async moveFiles(movingObj, db) {
        const response = await axios.put(`${url}/ProjectManagment/${db}/MoveFiles`, movingObj);
        return response.data;
    }

    static async moveMediaFolders(movingObj, db) {
        const response = await axios.put(`${url}/ProjectManagment/${db}/MoveMediaFolders`, movingObj);
        return response.data;
    }

    static async moveProcedures(movingObj, db) {
        const response = await axios.put(`${url}/ProjectManagment/${db}/MoveProcedures`, movingObj);
        return response.data;
    }

    static async moveFolders(movingObj, db) {
        const response = await axios.put(`${url}/ProjectManagment/${db}/MoveFolders`, movingObj);
        return response.data;
    }

    static async searchProcedureSessions(projectId, searchObj, db) {
        const response = await axios.post(`${url}/ProjectManagment/${db}/${projectId}/SearchProcedureSessions`, searchObj);
        return response.data;
    }

    static async getAllUsersWithSessionsInProject(projectId, domain) {
        const result = await axios.post(`${url}/ProjectManagment/${domain}/UsersWithSessionsInProject`, {
            projectId
        });
        return result.data;
    }

    static async getRoleVisibilitySummary(projectId, domain) {
        const result = await axios.get(`${url}/ProjectManagment/${domain}/${projectId}/GetRoleVisibilitySummary`);
        return result.data;
    }

    static async applyRoleVisibilityChanges(projectId, changes, domain) {
        const result = await axios.post(`${url}/ProjectManagment/${domain}/${projectId}/ApplyRoleVisibilityChanges`, {changes});
        return result.data;
    }

    static async getFastTrackProjects(workspace, email, password) {
        const result = await axios.post(`${url}/ProjectManagment/${workspace}/get-fast-track-projects`, {
            email, password
        });
        return result.data;
    }

    static async getProjectInteractions(workspace, projectId) {
        const result = await axios.get(`${url}/InteractiveIOManagment/${workspace}/${projectId}/GetAllInteractiveIOs`);
        return result.data;
    }

    static async duplicateFolder(importedFromWorkspace, folderId, projectId, workspace) {
        const result = await axios.post(`${url}/ProjectManagment/${workspace}/duplicate-folder/`, {
            importedFromWorkspace, folderId, projectId
        });
        return result.data;
    }

    static async createOrUpdateSitePrepTemplate(db, sitePrepTemplate) {
        const response = await axios.put(`${url}/ProcedureManagment/upsert-site-prep-template/${db}`, sitePrepTemplate);
        return response.data;
    }

    static async getSitePrepTemplates(db, projectId) {
        const result = await axios.get(`${url}/ProcedureManagment/get-site-prep-templates/${db}/${projectId}`);
        return result.data
    }

    static async deleteSitePrepTemplate(db, templateId) {
        await axios.delete(`${url}/ProcedureManagment/delete-site-prep-template/${db}/${templateId}`);
    }

    static async checkSameNameProcedure(procedureName, projectRef, db) {
        const result = await axios.post(`${url}/ProcedureManagment/${db}/check-same-name-procedure/`, {
            projectRef,
            procedureName
        });
        return result.data
    }

    static async adminGetAllProjects(workspace) {
        const result = await axios.get(`${url}/ProjectManagment/${workspace}/admin-get-all-projects/`);
        return result.data
    }

}
